import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  loading: boolean;
  error: boolean;
  oneTimeSignatureDetails: {
    // documents: {
    //   name: string;
    //   filename: string;
    //   signatureDate: string;
    // }[];

    documentIsSet: boolean;
    addresses: {
      addressLine1: string;
      addressLine2: string;
      addressLine3: string;
      city: string;
      state: string;
      postalCode: string;
      source: string;
    }[];
  };
  errorMessage: string;
} = {
  loading: false,
  error: false,
  oneTimeSignatureDetails: {} as {
    // documents: {
    //   name: string;
    //   filename: string;
    //   signatureDate: string;
    // }[];

    documentIsSet: boolean;

    addresses: {
      addressLine1: string;
      addressLine2: string;
      addressLine3: string;
      city: string;
      state: string;
      postalCode: string;
      source: string;
    }[];
  },
  errorMessage: "",
};
const oneTimeSignatureAddressesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ONE_TIME_SIGNATURE_ADDRESSES_STARTED:
      return updateObject(state, {
        loading: true,
        error: false,
        oneTimeSignatureDetails: initialState.oneTimeSignatureDetails,
        errorMessage: "",
      });
    case actionTypes.GET_ONE_TIME_SIGNATURE_ADDRESSES_SUCCESS:
      return updateObject(state, {
        loading: false,
        error: false,
        oneTimeSignatureDetails: action.oneTimeSignatureDetails,
        errorMessage: "",
      });
    case actionTypes.GET_ONE_TIME_SIGNATURE_ADDRESSES_FAILED:
      return updateObject(state, {
        loading: false,
        error: true,
        oneTimeSignatureDetails: initialState.oneTimeSignatureDetails,
        errorMessage: action.errorMessage,
      });
    default:
      return state;
  }
};

export default oneTimeSignatureAddressesReducer;
